//componente layout pour le qrcodeimport { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, effect, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { filter, startWith, Subscription } from 'rxjs';
import { ILanguage } from '@app/common-codes/_models/ILanguageDedinition';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { NavigationService } from '@app/common-codes/services/navigation.service';
import { Tenant } from '@app/common-codes/models/matwins-tenant/Tenant.model';
import { DependencyInjectionProvider } from '@app/common-codes/services/DependecyInjection.provider';
import { DataService } from '@app/common-codes/services/DataService';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { LoaderService } from '@app/common-codes/services/loader.service';
import { PointOfService } from '@app/common-codes/models/matwins-tenant/PointOfService.model';

@Component({
    selector: 'app-qrcode-layout',
    templateUrl: './qrcode-layout.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterModule,
        CommonModule,
        TranslatePipe
    ]
})
export class QRCodeLayoutComponent implements OnInit {
    // Ce layout ne nécessite pas d'authentification
    // C'est un layout simple qui permet d'afficher le contenu des composants enfants
    // via le router-outlet
    isLoading = false;

    currentTime = new Date()
    currentLanguage = 'en';
    private langSubscription: Subscription = new Subscription();
    langMenuOpen = false;
    languages: ILanguage[] | undefined = [];
    sub: any;

    routerSub: Subscription = new Subscription();
    router = inject(Router);

    tenantService: DataService<Tenant>;
    pointOfServiceService: DataService<PointOfService>;

    private matwinsArgsLoaded = signal<boolean>(false);
    private languageLoaded = false;


    constructor(public translationService: TranslationService,
        private activatedroute: ActivatedRoute,
        private variables: MatwinsVariablesService,
        public navService: NavigationService,
        private di: DependencyInjectionProvider,
        private currentTenantService: CurrentTenantService,
        public loaderService: LoaderService
    ) {
        this.tenantService = this.di.getOrCreateDataService(Tenant);
        this.pointOfServiceService = this.di.getOrCreateDataService(PointOfService);

        effect(() => {
            let loaded = this.matwinsArgsLoaded();
            if (loaded) {
                const path = this.router.url;

                // const currentRoute = `/qrcode/${this.variables.clientId}/${this.variables.posId}/home`;
                this.navService.initializeWith(path);
                this.translationService.initializeLanguage();

            }

        });
    }

    ngOnInit(): void {
        this.translationService.managedLanguages$.subscribe(languages => {
            if (languages && languages.length > 0 && !this.languageLoaded) {
                this.languages = languages;
                this.languageLoaded = true;
            }
        });

        // S'abonner aux changements de langue
        this.langSubscription = this.translationService.currentLanguage$.subscribe(lang => {
            this.currentLanguage = lang;
        });
        setInterval(() => {
            this.currentTime = new Date();
        }, 1000);

        this.sub = this.activatedroute.paramMap.subscribe(async params => {
            this.variables.clientId = params.get('tenant');
            this.variables.posId = params.has('pos') ? parseInt(params.get('pos') || '0') : null;
            if (this.variables.clientId && this.variables.posId) {
                var tenant = await this.tenantService.execute<Tenant>('GET', 'getByClientId', { clientId: this.variables.clientId, posId: this.variables.posId });
                this.currentTenantService.currentTenant.set(tenant);
                this.currentTenantService.currentClientId.set(this.variables.clientId);
                const pos = await this.pointOfServiceService.get(this.variables.posId!);
                this.currentTenantService.currentPointOfService.set(pos);
                this.currentTenantService.currentPointOfServiceId.set(this.variables.posId);
                this.matwinsArgsLoaded.set(true);

            }
        });


        //  Détection checkin / checkout
        this.routerSub = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            startWith({} as NavigationEnd)
        ).subscribe(() => {
            let currentRoute: ActivatedRoute | null = this.activatedroute;

            // On descend jusqu'au dernier enfant activé
            while (currentRoute?.firstChild) {
                currentRoute = currentRoute.firstChild;
            }

            // On prend le dernier segment du path
            const childPath = currentRoute?.snapshot.url.map(segment => segment.path).join('/') || '';
            let operation = childPath.replace('trucker-', '').toLowerCase().trim();
            // Extraire seulement la première partie (avant le /)
            operation = operation.split('/')[0];
            this.variables.ckeckOperation = operation == "checkin" || operation == 'checkout' || operation == 'edit' ? operation : undefined;
            this.variables.currentEntityId = currentRoute?.snapshot.params['id'] || null;

            //this.variables.variablesChanged$.set(undefined);
        });


    }

    ngOnDestroy() {
        this.langSubscription.unsubscribe();
    }

    goBack() {
        this.navService.goBack();
    }

    canGoBack(): boolean {
        return this.navService.canGoBackAny();
    }

    toggleLangMenu() {
        this.langMenuOpen = !this.langMenuOpen;
    }

    closeLangMenu() {
        this.langMenuOpen = false;
    }

    async changeLanguage(languageKey: string) {
        this.langMenuOpen = false;
        this.isLoading = true;

        try {
            await this.translationService.use(languageKey);
        } catch (error) {
            console.error('Erreur lors du changement de langue:', error);
        } finally {
            this.isLoading = false;
        }
    }

    // obtenir le nom de la langue courante
    getCurrentLanguageName(): string {
        const currentLang = this.languages?.find(lang => lang.key === this.currentLanguage);
        return currentLang ? currentLang.name : this.currentLanguage;
    }

    // obtenir l'emoji du drapeau (fallback si le logo n'est pas encore charge)
    getFlagEmoji(languageKey: string): string {
        const flagMap: { [key: string]: string } = {
            'en': '🇬🇧',
            'en-us': '🇺🇸',
            'en-ca': '🇨🇦',
            'fr': '🇫🇷',
            'fr-ca': '🇨🇦',
            'es': '🇪🇸'
        };
        return flagMap[languageKey] || '🌐';
    }
}
